import React, {useEffect, useState} from 'react';
import csvDownloadWithNulls from '../../utils/CsvDownloadWithNulls';
import {filterCaseInsensitiveReactTable} from "../../utils/filter";
import ReactTable from "../Components/ReactTable";
import {PAST_DUE_COLUMNS} from "./opsAlertsContentConstants";
import {makeApiCall} from "../../Api/makeApiCall";
import Checkbox from "../Components/Checkbox";
import {makeApolloClientCall} from "../../Api/makeApolloApiCall";
import {LoadingWrapper} from "../Components/LoadingWrapper";
import Page from "../Components/Page";
import {Breadcrumbs} from "../Components/Breadcrumbs";


const PastDuePage = () => {
    const [displayData, updateDisplayData] = useState([]);
    const [checkbox, updateCheckbox] = useState(false);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    function formatDataForDownload(displayData) {
        const objectToUse = displayData.map(row => {
            return {
                retailerId: row.retailerId,
                retailerName: row.retailChain,
                rollUpDayOfWeek: row.rollUpDayOfWeek,
                lastCleansedDate: row.maxSalesEndDate,
                daysPastDue: row.daysPastDue,
                active: row.salesforceRetailer?.active?.toString() || 'false'
            }
        })
        csvDownloadWithNulls(objectToUse);
    }

    useEffect(() => {
        setLoading(true);
        setError(false);
        const pastDueQuery = `{
            pastDue{
               retailerId
               retailChain
               rollUpDayOfWeek
               maxSalesEndDate
               daysPastDue
               salesforceRetailer { active accountId companyType accountManager retailerAssociation }
            }
         }`
        Promise.all([
            makeApolloClientCall(pastDueQuery)
        ]).then((pastDueResponse) => {
            const pastDue = pastDueResponse.length > 0 ? pastDueResponse[0].pastDue : []
            setData(pastDue);
            setLoading(false);
        }).catch(e => {
            console.log(e);
            setError(true)
            setLoading(false);
            setData([]);
        }).finally(() => {
            setLoading(false);
        });
    }, [])

    useEffect(() => {
        if (checkbox) {
            makeApiCall(`${process.env.REACT_APP_EDP_API_BASE_URL}/receiptLag/`)
                .then(receiptData => {
                    let filteredData = [];
                    data.forEach(element => {
                        const existsInBoth = !!receiptData.data.find(e => e.retailerId === element.retailerId);
                        if (existsInBoth) {
                            receiptData.data.forEach(r => {
                                if ((element.retailerId === r.retailerId && element.daysPastDue > r.receiptLag)) {
                                    filteredData.push(element)
                                }
                            })
                        } else if (!existsInBoth && element.daysPastDue > 0) {
                            filteredData.push(element)
                        }
                    })
                    updateDisplayData(filteredData)
                });
        }
        updateDisplayData(data)
    }, [data, checkbox])

    return (
        <Page name={'Past Due'}
              breadCrumbs={<Breadcrumbs items={[{label: 'Alerts'}, {label: 'Past Due'}]}/>}>
            <LoadingWrapper loading={loading}>
                <div id={'check-boxes'}>
                    <div className={'checkbox-group'}>
                        <div className={'checkbox-checkboxes'}>
                            <Checkbox labelText={'Include Receipt Lag'}
                                      onChange={() => updateCheckbox(!checkbox)}
                                      checked={checkbox}/>
                        </div>
                    </div>
                </div>
                <br/>
                <div className={'past-due-downloads-div'}>
                    <button className="hollow button secondary past-due-downloads"
                            onClick={() => formatDataForDownload(displayData)}>
                        {'Download CSV'}
                    </button>
                </div>
                {!error && <ReactTable
                    filterable={true}
                    data={displayData}
                    columns={PAST_DUE_COLUMNS}
                    initialState={{
                        columnFilters: [{id: 'Active', value: 'true'}],
                        sorting: [{id: 'daysPastDue', desc: true}]
                    }}
                    getTrProps={(rowInfo) => {
                        let className = '';
                        if (rowInfo?.original.daysPastDue >= 28) {
                            className = 'left-gutter-alert'
                        } else if (rowInfo?.original.daysPastDue > 7) {
                            className = 'left-gutter-warning'
                        }
                        return {className};
                    }}
                    defaultFilterMethod={filterCaseInsensitiveReactTable}
                />}
                {error && <div className={'error-div'} data-testid={'error-div'}>Error has occurred please try again</div>}
            </LoadingWrapper>
        </Page>
    )
}

export default PastDuePage;